/* globals jQuery */
import { easing, animSpeed } from './_vars.js';

(function(window, document, $) {
  $(document).ready(function() {

    function removeHeading (previousAnswer) {
      if (previousAnswer[0] !== $('.active-answer')[0]) {
        previousAnswer.find('h4').remove();
      }
    }

    function setQuestion (event) {
      var activeQuestion = event.target;
      var answer = $(activeQuestion).next('.answer');
      var previousQuestion = $('.active-question');
      var previousAnswer = $('.active-answer');
      if (previousQuestion[0] !== activeQuestion) {
        $('.active-answer').removeClass('active-answer');
        if (!answer.find('h4').length) {
          answer.prepend('<h4>' + $(activeQuestion).text() + '</h4>');
        }
        if (window.innerWidth <= 650 ) {
          previousAnswer.slideUp( animSpeed, easing ).removeClass('active-answer');
          answer.slideDown( animSpeed, easing ).addClass('active-answer');
        } else {
          previousAnswer.fadeOut( animSpeed, "linear", function () { removeHeading(previousAnswer); });
          answer.fadeIn( animSpeed, "linear" ).addClass('active-answer');
        }
      }
      
      previousQuestion.removeClass('active-question');
      $(activeQuestion).addClass('active-question');
    }

    $('.question').on('click', setQuestion);
    $('.question:first').click();
  });
}(window, document, jQuery));